import { BillingQuestionComponent } from '../../billing/billing-question/billing-question.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component , NO_ERRORS_SCHEMA } from '@angular/core';
import { FaqService } from '@services/faq.service';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, BillingQuestionComponent],
  selector: 'app-faq-policy',
  templateUrl: './faq-policy.component.html',
  styleUrls: ['./faq-policy.component.scss'],
})
export class FaqPolicyComponent {
  accordianWithMDB: any = {};

  constructor(private faqService: FaqService) {
    this.accordianWithMDB = this.faqService.getAccordianWithMDB();
  }

  closeNonActiveCollapse(name): void {
    const acc = this.accordianWithMDB;
    for (const element in acc) {
      if (element != name) {
        acc[element] = false;
      }
    }
    acc[name] = !acc[name];
  }

}
